module.exports = __webpack_public_path__ + "static/media/plantFour.5d8aaed7.jpg";